import script from "./CoachPerks.vue?vue&type=script&setup=true&lang=js"
export * from "./CoachPerks.vue?vue&type=script&setup=true&lang=js"

import "./CoachPerks.vue?vue&type=style&index=0&id=1c882ca7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c882ca7"]])

export default __exports__